import React from 'react'
import ReactDOM from 'react-dom'

import * as serviceWorker from './serviceWorker'

import './index.css'
import 'react-toastify/dist/ReactToastify.css'

import { IntlProvider } from 'react-intl'
import App from './App'

import * as Sentry from '@sentry/browser'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN
  })
}

ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale={navigator.language}>
      <App />
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorker.unregister()
